module.exports = __webpack_public_path__ + "static/img/account_logo.ba619df.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/account_logo.png
// module id = 48
// module chunks = 1